module.exports = __webpack_public_path__ + "static/battle_10-8179449a106a85c710c37f383c687c4f.jpg";